import pathsManifest from '../../pathsManifest';

const defaultContext = {
  brand: 'zillow',
  isInMobileWebView: false,
  paths: pathsManifest.getAllPaths('zillow'),
};

export default defaultContext;
